import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FormikProps } from 'formik';
import { Button, FormControl, Unstable_Grid2 as Grid } from '@mui/material';

import { ContentInput } from 'api';
import { Loaders } from 'components';

import { ExternalSharePostSchema, usePostContext } from 'features/posting';
import { sharingSchema } from 'features/sharing/validations';
import { Share } from 'features/sharing/types';
import { useUploadCount } from 'features/posting/components/ImageVideo/UploadCountProvider';

interface Props {
  loading: boolean;
  onSubmit: () => void;
  postFormikProps: FormikProps<ContentInput>;
  shareFormikProps: FormikProps<Share>;
}

const FormButtons: FC<Props> = ({ loading, onSubmit, postFormikProps, shareFormikProps }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { state } = usePostContext();

  const { values: postValues } = postFormikProps;
  const { values: shareValues } = shareFormikProps;

  const isPostValid = ExternalSharePostSchema.isValidSync(postValues, {
    uiState: state,
  });
  const isShareValid = sharingSchema.isValidSync(shareValues);
  const { uploadCount } = useUploadCount();
  const disabled = !isPostValid || !isShareValid || loading || !!uploadCount;

  return (
    <FormControl variant="standard" fullWidth>
      <Grid container alignItems="center" justifyContent="flex-end">
        <Grid>
          <Button variant="text" onClick={() => navigate(-1)}>
            {t('common:cancel')}
          </Button>
        </Grid>

        <Grid xs={2}>
          <Button
            fullWidth
            size="large"
            color="primary"
            variant="contained"
            disabled={disabled}
            onClick={onSubmit}
          >
            {loading || !!uploadCount ? <Loaders.Standard height={26} /> : t('common:share')}
          </Button>
        </Grid>
      </Grid>
    </FormControl>
  );
};

export default FormButtons;
